import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { OrderWarehouseConfigFieldsFragmentDoc } from '../fragments/orderWarehouseConfig.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetOrderWarehouseConfigMutationVariables = Types.Exact<{
  input: Types.OrderWarehouseConfigInput;
}>;


export type SetOrderWarehouseConfigMutation = { __typename?: 'Mutation', setOrderWarehouseConfig: { __typename?: 'OrderWarehouseConfig', non_event: { __typename?: 'WarehouseRouting', default_warehouse_uuid?: string | null, fallback_warehouse_uuid: string, countries: Array<{ __typename?: 'WarehouseRoutingCountryEntry', country_code: string, warehouse_uuid: string }> }, event: { __typename?: 'WarehouseRouting', default_warehouse_uuid?: string | null, fallback_warehouse_uuid: string, countries: Array<{ __typename?: 'WarehouseRoutingCountryEntry', country_code: string, warehouse_uuid: string }> } } };


export const SetOrderWarehouseConfigDocument = gql`
    mutation SetOrderWarehouseConfig($input: OrderWarehouseConfigInput!) {
  setOrderWarehouseConfig(input: $input) {
    ...OrderWarehouseConfigFields
  }
}
    ${OrderWarehouseConfigFieldsFragmentDoc}`;
export type SetOrderWarehouseConfigMutationFn = Apollo.MutationFunction<SetOrderWarehouseConfigMutation, SetOrderWarehouseConfigMutationVariables>;

/**
 * __useSetOrderWarehouseConfigMutation__
 *
 * To run a mutation, you first call `useSetOrderWarehouseConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderWarehouseConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderWarehouseConfigMutation, { data, loading, error }] = useSetOrderWarehouseConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOrderWarehouseConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetOrderWarehouseConfigMutation, SetOrderWarehouseConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOrderWarehouseConfigMutation, SetOrderWarehouseConfigMutationVariables>(SetOrderWarehouseConfigDocument, options);
      }
export type SetOrderWarehouseConfigMutationHookResult = ReturnType<typeof useSetOrderWarehouseConfigMutation>;
export type SetOrderWarehouseConfigMutationResult = Apollo.MutationResult<SetOrderWarehouseConfigMutation>;
export type SetOrderWarehouseConfigMutationOptions = Apollo.BaseMutationOptions<SetOrderWarehouseConfigMutation, SetOrderWarehouseConfigMutationVariables>;